import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { jwtDecode } from 'jwt-decode';
import { Stack, Button, Container, Typography, Box } from '@mui/material';

import { authContext } from '../routes';
import Iconify from '../components/iconify';
import { AnnouncePayment, MyPayments, NewBankAccount } from '../sections/payment';
import SERVER_API_URL from '../config';
import axiosInstance from '../api';

export default function PaymentPage() {
  const { user } = useContext(authContext);
  const [paymentActivatedOn, setPaymentActivatedOn] = useState('list');
  const [bankAccounts, setBankAccounts] = useState([])
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      const expirationDate = new Date(decodedToken.exp * 1000);
      if (expirationDate < new Date()) {
        localStorage.clear();
        navigate('/login');
      } else if (user && !user.role.permissions.payment.read) {
        navigate('/dashboard');
      }
    } else {
      navigate('/login');
    }
  }, [navigate, user]);

  const getBanks = useCallback(async () => {
    try {
      const response = await axiosInstance.get(`${SERVER_API_URL}/payment/getBanks`);

      if (response.status === 200) {
        setBankAccounts(response.data);
      }
    } catch (e) {
      // setFormError('የተመዘገቡ ባንኮችን በማግኘት ላይ ችግር አለ!');
      // setFormErrorSeverity('error');
    }
  }, [])

  useEffect(() => {
    getBanks();
  }, [getBanks]);

  return (
    <>
      <Helmet>
        <title> ዐመታዊ ክፍያ | የሰ/ሸ/ሃ/መ/አ/ስርዓት </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: { xs: 2, sm: 5 } }}>
          <Typography variant="h4" color="text.secondary">
            ዐመታዊ ክፍያ
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'right', gap: { xs: 1, sm: 2 } }}>
            {user && user.role.permissions.payment.read && (
              <Button
                disabled={paymentActivatedOn === 'list'}
                variant="contained"
                startIcon={<Iconify icon="eva:list-fill" />}
                onClick={() => setPaymentActivatedOn('list')}
                color="success"
              >
                <Typography sx={{ display: { xs: 'none', sm: 'block' } }}>የኔ ክፍያ</Typography>
              </Button>
            )}
            {user && user.role.permissions.payment.create && (
              <Button
                disabled={paymentActivatedOn === 'newAdd'}
                variant="contained"
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => setPaymentActivatedOn('newAdd')}
                color="warning"
              >
                <Typography sx={{ display: { xs: 'none', sm: 'block' } }}>ክፍያ አሳውቅ</Typography>
              </Button>
            )}

            {user && user.role.permissions.payment.create && (
              <Button
                disabled={paymentActivatedOn === 'newAccount'}
                variant="contained"
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => setPaymentActivatedOn('newAccount')}
                color="info"
              >
                <Typography sx={{ display: { xs: 'none', sm: 'block' } }}>አዲስ አካውንት</Typography>
              </Button>
            )}
          </Box>
        </Stack>
        {user && user.role.permissions.payment.read && paymentActivatedOn === 'list' && <MyPayments user={user} />}
        {user && user.role.permissions.payment.create && paymentActivatedOn === 'newAdd' && (
          <AnnouncePayment user={user} bankAccounts={bankAccounts} />
        )}
        {user && user.role.permissions.payment.create && paymentActivatedOn === 'newAccount' && (
          <NewBankAccount user={user} getBanks={getBanks} />
        )}
      </Container>
    </>
  );
}
